export default __webpack_public_path__ + "static/media/3.5d60ad10.png";